import {
  PitchTypeRangesChartConfigDto,
  PitcherSessionReportChartConfigDto,
  PitchTypeRangesMeasurementOptions,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const options: PitchTypeRangesMeasurementOptions[] = ['Velocity', 'SpinRate', 'InducedVerticalBreak', 'HorizontalBreak'];

const PitcherSessionPitchTypeRangesChartSidebar = ({
  chartConfig,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<PitchTypeRangesChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('PitcherSessionPitchTypeRangesChart', chartConfig)}
      </Typography>

      <GenericRadioConfig
        label={t('X-Axis')}
        options={options}
        selected={chartConfig.selectedMeasurementOption}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            pitcherSessionPitchTypeRangesChartConfig: {
              ...tempLayout.pitcherSessionPitchTypeRangesChartConfig,
              selectedMeasurementOption: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default PitcherSessionPitchTypeRangesChartSidebar;
